(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DEFAULT_DURATION = 300;
  var EXPAND_EASING = 'cubic-bezier(0.11, 0, 0.5, 0)';
  var SHRINK_EASING = 'cubic-bezier(0.5, 1, 0.89, 1)';

  function FaqAccordionItem(details) {
    this.details = details;
    this.summary = details.querySelector('.faq-accordion__toggle');
    this.content = details.querySelector('.faq-accordion__answer');
    this.animation = null;
    this.contentAnimation = null;
    this.isClosing = false;
    this.isExpanding = false;
    details._faqAccordionItem = this;

    var list = details.closest('.faq-accordion__list');
    var durationAttr = list && list.dataset.duration;
    this.duration = durationAttr ? parseInt(durationAttr, 10) : DEFAULT_DURATION;
    if (!this.duration || isNaN(this.duration)) this.duration = DEFAULT_DURATION;

    if (this.summary && this.content) {
      this.summary.addEventListener('click', this.onClick.bind(this));
    }
  }

  FaqAccordionItem.prototype.onClick = function (event) {
    event.preventDefault();

    if (this.isClosing || !this.details.open) {
      this.openItem();
    } else {
      this.shrink();
    }
  };

  FaqAccordionItem.prototype.openItem = function () {
    var list = this.details.closest('.faq-accordion__list');
    if (list) {
      var items = list.querySelectorAll('.faq-accordion__item');
      for (var i = 0; i < items.length; i++) {
        var other = items[i]._faqAccordionItem;
        if (other && other !== this && other.details.open) {
          other.shrink();
        }
      }
    }

    this.details.classList.add('is-open');

    if (reduceMotion) {
      this.details.open = true;
      return;
    }

    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  FaqAccordionItem.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: this.duration, easing: EXPAND_EASING });
    this.animation.onfinish = this.onAnimationFinish.bind(this, true);
    this.animation.oncancel = function () {
      this.isExpanding = false;
    }.bind(this);

    if (this.contentAnimation) this.contentAnimation.cancel();
    this.contentAnimation = this.content.animate(
      { transform: ['translateY(10px)', 'translateY(0)'], opacity: [0, 1] },
      { duration: this.duration, easing: EXPAND_EASING }
    );
  };

  FaqAccordionItem.prototype.shrink = function () {
    this.isClosing = true;
    this.details.classList.remove('is-open');

    if (reduceMotion) {
      this.details.open = false;
      this.isClosing = false;
      return;
    }

    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: this.duration, easing: SHRINK_EASING });
    this.animation.onfinish = this.onAnimationFinish.bind(this, false);
    this.animation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);

    if (this.contentAnimation) this.contentAnimation.cancel();
    this.contentAnimation = this.content.animate(
      { transform: ['translateY(0)', 'translateY(10px)'], opacity: [1, 0] },
      { duration: this.duration, easing: SHRINK_EASING }
    );
  };

  FaqAccordionItem.prototype.onAnimationFinish = function (open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
  };

  document.querySelectorAll('.faq-accordion__item').forEach(function (details) {
    new FaqAccordionItem(details);
  });
})();
